// TODO Get rid of this context

import React from 'react';

export default React.createContext();
